import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../../stem-core/src/ui/Style";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";

import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../../../Messages";
import {AddFundsIcon} from "../../../../../SVGElements";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {MerchantUserResourcesAccessLink} from "../../../../../common/MerchantUserResourcesAccessLink";


class AddNewOrLoadCardComponentStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.PAYWALL_TITLE;

    @styleRule
    link = {
        ...this.themeProps.PAYWALL_LINK,
        alignSelf: "center",
    };

    @styleRule
    body = {
        display: "flex",
        ">*>*": {
            alignSelf: "center",
        },
        marginBottom: 18,
    };

    @styleRule
    addNewCard = {
        cursor: "pointer",
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_REGULAR,
        whiteSpace: "nowrap",
        display: "inline-block",
        ">*": {
            display: "inline-block",
        },
        ">:first-child": {
            transform: "translateY(1px)",
            marginRight: 4,
        },
    };

    @styleRule
    accessResources = this.themeProps.PANEL_ACCESS_RESOURCES;

    @styleRule
    accessResourcesLink = {
        marginTop: "0 !important",
    };
}

@registerStyle(AddNewOrLoadCardComponentStyle)
export class AddNewOrLoadCardComponent extends UI.Element {
    isValid() {
        return true;
    }

    getPaymentMethodId(scope, callback) {
        callback(this.options.card?.id);
    }

    render() {
        const {styleSheet} = this;
        const {onAddCard} = this.options;
        const extraPaymentMethodCount = iFrameUserDataService.getExtraPaymentMethodCount();

        return [
            <div className={styleSheet.title}>{Messages.cardComponentTitle}</div>,
            <div className={styleSheet.body}>
                <Link className={styleSheet.addNewCard} style={{color: this.styleSheet.themeProps.MERCHANT_LINK}} onClick={onAddCard}>
                    <AddFundsIcon size={12.25} color={this.styleSheet.themeProps.MERCHANT_LINK}/>
                    <span>{Messages.addNewPaymentMethod}</span>
                </Link>
                <div className={styleSheet.accessResources}>
                    {Messages.or}
                    <MerchantUserResourcesAccessLink className={styleSheet.accessResourcesLink} extraResourcesCount={extraPaymentMethodCount}/>
                </div>
            </div>
        ]
    }
}
